module.exports = __webpack_public_path__ + "2c8a2bdaa3f0a5b1b1d8ee06ac42f9d3.woff";